import { Box } from "@chakra-ui/react";
import { Outlet } from "react-router";
import { useEffect } from "react";
import useIdentity from "@/features/ui/hooks/use-identity";
import useRouterHelper from "@/features/ui/hooks/use-router-helper";
import AppCompanySelection from "@/features/ui/app-company-selection";
import {
  applyCompanyIdFromUrl,
  needsCompanySelection,
} from "@/features/ui/helpers/identity-helpers";

/**
 * 인증만 보장하고 네비게이션(상단바/좌측 SNB)은 렌더하지 않는 몰입형 전체화면 레이아웃.
 *
 * 네이버 솔루션 연동 온보딩처럼 외부(스마트스토어)에서 진입하는 단독 화면 흐름에 사용한다.
 * 인증/리다이렉트 동작은 PrivateLayout 과 동일하게 유지한다(미로그인 → 로그인 후 복귀).
 */
export default function PrivateBareLayout() {
  // useIdentity() 가 세션 값을 읽기 전에 ?company_id=... 를 먼저 반영한다.
  applyCompanyIdFromUrl();

  const identity = useIdentity();
  const { navigate, location } = useRouterHelper();

  useEffect(() => {
    if (identity === null) {
      // signOut 시 rerender 로 인한 오작동 방지용 hack (PrivateLayout 과 동일).
      setTimeout(() => {
        if (sessionStorage.getItem("signOut")) {
          sessionStorage.removeItem("signOut");
          return;
        }
        const redirectUrl = encodeURIComponent(
          location.pathname + location.search
        );
        navigate("/auth/sign-in?redirect_url=" + redirectUrl, { replace: true });
      }, 300);
    } else if (identity.company === null) {
      navigate("/auth/sign-up-pending", { replace: true });
    }
  }, [identity, location.pathname, location.search, navigate]);

  if (identity === null) {
    return null;
  }

  // PrivateLayout 과 동일하게, 회사를 고르기 전에는 화면을 열지 않는다.
  if (needsCompanySelection()) {
    return <AppCompanySelection />;
  }

  return (
    <Box height="100vh" overflow="auto" background="#FCFCFE">
      <Outlet />
    </Box>
  );
}
